import React, { useCallback, useEffect, useState } from "react";
import { Avatar, Badge, Button, Dropdown, List, Menu, message } from "antd";
import { BellOutlined, CheckCircleOutlined, WarningOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import Flex from "components/shared-components/Flex";
import api, { errorMessage } from "views/licenses/api";

export default function LicenseNavNotification() {
  const history = useHistory();
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({ items: [], unread: 0 });
  const [disabled, setDisabled] = useState(false);

  const load = useCallback(async () => {
    if (disabled) return;
    try {
      const result = (await api.notifications()) || {};
      setData({
        items: Array.isArray(result.items) ? result.items : [],
        unread: Number(result.unread) || 0,
      });
    } catch (error) {
      if (error?.response?.status === 403) setDisabled(true);
      setData({ items: [], unread: 0 });
    }
  }, [disabled]);

  useEffect(() => {
    load();
    if (disabled) return undefined;
    const timer = window.setInterval(load, 60000);
    return () => window.clearInterval(timer);
  }, [disabled, load]);

  const openNotification = async (item = {}) => {
    try {
      if (!item.read_at) await api.readNotification(item.id);
      setVisible(false);
      await load();
      if (item.action_url) {
        const parsed = new URL(item.action_url, window.location.origin);
        history.push(parsed.pathname);
      }
    } catch (error) {
      message.error(errorMessage(error));
    }
  };

  const readAll = async () => {
    try {
      await api.readAllNotifications();
      await load();
    } catch (error) {
      message.error(errorMessage(error));
    }
  };

  const body = (
    <div className="nav-dropdown nav-notification">
      <div className="nav-notification-header d-flex justify-content-between align-items-center">
        <h4 className="mb-0">Licencias</h4>
        <Button className="text-primary" type="text" onClick={readAll} size="small">
          Marcar todas leídas
        </Button>
      </div>
      <div className="nav-notification-body">
        {data.items.length ? (
          <List size="small" itemLayout="horizontal" dataSource={data.items}
            renderItem={(item) => (
              <List.Item className="list-clickable" onClick={() => openNotification(item)}>
                <Flex alignItems="center">
                  <div className="pr-3">
                    <Avatar className={item.read_at ? "" : "ant-avatar-warning"}
                      icon={item.event_type?.includes("CONFIRMED")
                        ? <CheckCircleOutlined /> : <WarningOutlined />} />
                  </div>
                  <div className="mr-3">
                    <span className="font-weight-bold text-dark">{item.title}</span>
                    <div className="text-gray-light">{item.message}</div>
                  </div>
                  {!item.read_at && <Badge status="processing" />}
                </Flex>
              </List.Item>
            )} />
        ) : (
          <div className="empty-notification">
            <p className="mt-3">No hay notificaciones de licencias.</p>
          </div>
        )}
      </div>
    </div>
  );

  if (disabled) return null;

  return (
    <Dropdown placement="bottomRight" overlay={body}
      onVisibleChange={(flag) => { setVisible(flag); if (flag) load(); }}
      visible={visible} trigger={["click"]}>
      <Menu mode="horizontal">
        <Menu.Item key="license-notification">
          <Badge count={data.unread}>
            <BellOutlined className="nav-icon mx-auto" />
          </Badge>
        </Menu.Item>
      </Menu>
    </Dropdown>
  );
}
